import React,
{
  useCallback,
  useMemo,
  useRef,
} from 'react';
import { useTranslation } from 'react-i18next';
import { IBillsTableBodyProps, IBillsTableRow } from '../types';
import { BillsTableRow } from './BillsTableRow';
import { useStore } from '../../../../../../../store';
import { BILLS_TABLE_NAMES_TITLES } from '../../../consts';

const TableStyles = {
  TableTBody: '',
  TableRow: 'h-[64px]',
  TableCell: 'py-3 first:pl-6 last:pr-6 text-sm text-bw08 font-metricR last-child:w-[145px]',
};

export const BillsTableBody = ({ columns, data, tableName }: IBillsTableBodyProps) => {
  const { t } = useTranslation();
  const incrementUnpaidBillsPageNumber = useStore(state => state.incrementUnpaidBillsPageNumber);
  const incrementPaidBillsPageNumber = useStore(state => state.incrementPaidBillsPageNumber);
  const columnKeys = useMemo(() => columns.map(item => item.key), [columns]);
  const observer = useRef<IntersectionObserver | null>(null);
  const lastRow = useCallback((callback: any) => {
    if (observer.current) observer.current?.disconnect();
    observer.current = new IntersectionObserver((entry, o) => {
      if (entry[0].isIntersecting) {
        if (tableName === t(BILLS_TABLE_NAMES_TITLES.UNPAID)) incrementUnpaidBillsPageNumber();
        if (tableName === t(BILLS_TABLE_NAMES_TITLES.PAID)) incrementPaidBillsPageNumber();
        o.unobserve(entry[0].target);
      }
    }, { rootMargin: '100px', root: null, threshold: 1 });
    if (callback) observer.current?.observe(callback);
  }, [data]);
  const renderRow = (row: IBillsTableRow, index: number) => (
    <BillsTableRow
      columnKeys={columnKeys}
      row={row}
      isLastRow={index === data.length - 1}
      key={`bill_${row.billNumber}_${index}`}
      lastRow={index === data.length - 1 ? lastRow : null}
    />
  );

  const buildTableRows = (rows: Array<IBillsTableRow>) => rows?.map(renderRow);

  const tableRows = buildTableRows(data);

  return (
    <tbody className={TableStyles.TableTBody}>
      {tableRows}
    </tbody>
  );
};
